// extracted by mini-css-extract-plugin
export var acitonButtons = "_dg-0";
export var additionalIcon = "_dg-f";
export var block = "_dg-1";
export var blockContent = "_dg-7";
export var blockDescription = "_dg-8";
export var blockIcon = "_dg-9";
export var blockTitle = "_dg-6";
export var border = "_dg-a";
export var center = "_dg-l";
export var edge = "_dg-b";
export var edgeLabel = "_dg-c";
export var edgePath = "_dg-d";
export var error = "_dg-e";
export var flowchart = "_dg-g";
export var flowchartContent = "_dg-h";
export var highlighted = "_dg-3";
export var hover = "_dg-4";
export var icon = "_dg-i";
export var left = "_dg-m";
export var navButton = "_dg-j";
export var navButtons = "_dg-k";
export var right = "_dg-n";
export var selected = "_dg-2";
export var small = "_dg-5";